import { FC } from 'react';
import Steps from './steps';
import Step from './step';
import {
  StepsProps,
  StepProps,
  horizontalAlignType,
  statusType,
} from './interface';
import './style.less';

export type { StepsProps, StepProps, horizontalAlignType, statusType };

export type IStepsComponent = FC<StepsProps> & {
  Step: FC<StepProps>;
};
/** 状态进度条 */
const TransSteps = Steps as IStepsComponent;
TransSteps.Step = Step;

export default TransSteps;
